import {$api} from "../http/index";

export default class TaskService {
    static async createTask(task) {
        return  $api.post('api/task', task)
    }

    static async createTaskFile(task) {
        return  $api.post('api/task/file', task)
    }

    static async createTaskToMsg(task) {
        return  $api.post('api/task/tomsg', task)
    }

    static async createTaskFileToMsg(task) {
        return  $api.post('api/task/filetomsg', task)
    }



}